import Auth from '@aws-amplify/auth';
import { userSessionMgr } from './user-session-mgr';

/**
 * Given that there are now capabilities and cities are both stored as
 * Cognito groups, we need to have a list that can be used to filter out
 * groups that are not cities and are not caught by simple searching "@"
 */
const ignoredGroups = ['admin', 'include_cities'];

export class DeckardCognitoUser {
  static FIRST_CITY_INDEX = 0;

  static ADMIN_GROUP = 'admin';

  static VERSION = '1';

  static LAST_AUTHED_EMAIL_LS_KEY = `lastAuthedEmail_v${DeckardCognitoUser.VERSION}`;

  static DEFAULT_CITY_STORAGE_KEY = 'defaultCity';

  static async setDefaultCity(place) {
    const user = await Auth.currentAuthenticatedUser();
    userSessionMgr.setDefaultCitySession(place, user.username);
  }

  static async setLastAuthedEmail(email) {
    window.localStorage.setItem(
      DeckardCognitoUser.LAST_AUTHED_EMAIL_LS_KEY,
      email
    );
  }

  static async getLastAuthedEmail() {
    return window.localStorage.getItem(
      DeckardCognitoUser.LAST_AUTHED_EMAIL_LS_KEY
    );
  }

  constructor(cognitoUser) {
    if (!cognitoUser) {
      throw new Error(
        'Missing cognito user from DeckardCognitoUser constructor'
      );
    }
    this.cognitoUser = cognitoUser;
    this.jwtPayload = cognitoUser.signInUserSession.idToken.payload;
  }

  cognitoUser = null;

  jwtPayload = null;

  get authorizedCities() {
    const authorizedCities = [];

    this.userGroups.forEach((group) => {
      if (group.includes('@') || ignoredGroups.includes(group)) return;
      authorizedCities.push(group);
    });

    return authorizedCities;
  }

  get userGroups() {
    return this.jwtPayload['cognito:groups'];
  }

  get isAdminGroup() {
    return this.userGroups.includes(DeckardCognitoUser.ADMIN_GROUP);
  }

  get defaultCity() {
    const defaultCitySession = userSessionMgr.getDefaultCitySession();
    if (this.defaultCitySession) {
      return defaultCitySession;
    }
    // If nothing found in sessionStorage, returning null should cause the caller to try to get the
    // value from strOracle /defaultPlace endpoint
    return null;
  }

  get username() {
    return this.jwtPayload['cognito:username'];
  }

  get firstName() {
    return this.jwtPayload.given_name;
  }

  get lastName() {
    return this.jwtPayload.family_name;
  }
}

/*
 * DON'T DELETE THIS. This function is exposed on purpose so that devs
 * can be able to change the default city when the app is broken
 */
window.setDefaultCity = async (newDefaultCity) => {
  console.info('Setting new default city: ', newDefaultCity); // eslint-disable-line no-console
  const result = await DeckardCognitoUser.setDefaultCity(newDefaultCity);
  return result;
};
